import { ReportBundleFrontendController } from '@/frontend/controllers/reportBundleFrontendController';
import { LoadedReportModule, evaluateReportRuntime } from './runtime';

export { evaluateReportRuntime } from './runtime';
export type { AnyReportDefinition, LoadedReportModule } from './runtime';

/**
 * Where the browser gets a report to render: a report bundle, whose compiled
 * scripts are fetched by version id and evaluated against the host installed
 * by host.ts. Versions are immutable, so a loaded bundle is cached for the
 * life of the page.
 */

export interface ReportModuleRef {
  key: string;
  /** the bundle version to load; null when there is none to load */
  bundleVersionId: string | null;
}

const loaded = new Map<string, Promise<LoadedReportModule>>();

/** null when the ref names no bundle version. */
export function loadReportModule(ref: ReportModuleRef): Promise<LoadedReportModule | null> {
  if (!ref.bundleVersionId) return Promise.resolve(null);
  let pending = loaded.get(ref.bundleVersionId);
  if (!pending) {
    pending = new ReportBundleFrontendController().runtime(ref.bundleVersionId).then((response) => {
      if (response.status !== 200 || !response.runtime) {
        throw new Error(response.errors?.[0]?.message ?? `HTTP ${response.status}`);
      }
      return evaluateReportRuntime(response.runtime);
    });
    pending.catch(() => loaded.delete(ref.bundleVersionId as string));
    loaded.set(ref.bundleVersionId, pending);
  }
  return pending;
}

/** For tests and the studio: forget a loaded version. */
export function forgetReportModule(bundleVersionId: string): void {
  loaded.delete(bundleVersionId);
}
